//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import util from '@/lib/util';

export default {
    name: "projectSale",
    data() {
        return {
            downloadUrl: util.ApiUrl + '/file/download/',
            list: []
        }
    },
    methods: {
        goToProjectSale(id) {
            this.$router.push({path: '/onSale/' + id})
        },
        getPage() {
            var page = {
                maxResultCount: 10,
                skipCount: 0
            };
            abp.ajax.post('/api/services/app/LouShu/SearchLouShu', page).then(res => {
                this.list = [];
                this.list.push(...res.data.result.items)
            })
        }
    },
    created() {
        this.getPage()
    }
}
